var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center page-not-found"},[_c('div',{staticClass:"text-h1 transition-swing"},[_vm._v("\n                Oops!..\n            ")]),_vm._v(" "),_c('div',{staticClass:"grey--text my-3"},[_vm._v("\n                No tienes permisos para accesar o no existe la ruta.\n            ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }